export function enforceNumeric(value: string) {
  return value.replace(/\D/g, '');
}
